import { useEffect } from "react";
import CouncilBluffsHeroSection from "./components/HeroSection";
import CouncilBluffsStickyNav from "./components/StickyNav";
import CouncilBluffsProcessingTimeSection from "./components/ProcessingTimeSection";
import CouncilBluffsServicesSection from "./components/ServicesSection";
import CouncilBluffsLocalAreaSection from "./components/LocalAreaSection";
import CouncilBluffsTestimonialsSection from "./components/TestimonialsSection";
import CouncilBluffsAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import CouncilBluffsComparisonSection from "./components/ComparisonSection";
import CouncilBluffsMistakesSection from "./components/MistakesSection";
import CouncilBluffsHowItWorksSection from "./components/HowItWorksSection";
import CouncilBluffsFAQSection, { faqs } from "./components/FAQSection";
import CouncilBluffsHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import CouncilBluffsFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function CouncilBluffsPage() {
  useEffect(() => {
    document.title = "Emergency Passport Council Bluffs IA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/council-bluffs/";

    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Council Bluffs, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Pottawattamie County, the Omaha metro area, and Southwest Iowa residents.");
    setMeta("geo.placename", "Council Bluffs, Iowa");
    setMeta("geo.region", "US-IA");
    setMeta("geo.position", "41.2619;-95.8608");
    setMeta("ICBM", "41.2619, -95.8608");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "Iowa", item: "https://fastpassportcenter.com/iowa/" },
          { "@type": "ListItem", position: 3, name: "Council Bluffs Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Emergency and expedited passport services for Council Bluffs and the Omaha metro area. As fast as 24 hours.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "Council Bluffs", containedInPlace: { "@type": "State", name: "Iowa" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data";
    document.getElementById("structured-data")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data")?.remove();
      document.querySelector('link[rel="canonical"]')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <CouncilBluffsHeroSection />
      <CouncilBluffsStickyNav />
      <CouncilBluffsProcessingTimeSection />
      <CouncilBluffsServicesSection />
      <CouncilBluffsLocalAreaSection />
      <CouncilBluffsTestimonialsSection />
      <CouncilBluffsAcceptanceFacilitiesSection />
      <CouncilBluffsComparisonSection />
      <CouncilBluffsMistakesSection />
      <CouncilBluffsHowItWorksSection />
      <CouncilBluffsFAQSection />
      <CouncilBluffsHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/council-bluffs" state="IA" />
      <CouncilBluffsFinalCTA />
    </div>
  );
}